import React, { useState } from 'react';
import { FaBriefcase, FaComment, FaUser } from 'react-icons/fa';
import { FaRightFromBracket } from 'react-icons/fa6';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Separator } from '@/components/ui/separator';
import GenderPreferenceToggle from './GenderPreferenceToggle';

const ProfileBtn = ({ setModal }) => {
    const user = localStorage.getItem("user");
    const [profile, setProfile] = useState(null);

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    id="profile-menu-btn"
                    className="bg-white text-neutral-800 hover:bg-neutral-50 flex gap-2 items-center font-medium px-3 py-2 rounded-lg border border-neutral-200 shadow-sm"
                >
                    <FaUser className="text-amber-500" />
                    <span>Profile</span>
                    <svg
                        className="ml-2 -mr-1 h-4 w-4 text-neutral-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                            clipRule="evenodd"
                        />
                    </svg>
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-80 p-3.5 rounded-xl shadow-lg border border-neutral-200 bg-white">
                <div className="flex flex-col items-center gap-1.5 w-full">
                    <div className="flex flex-col items-center w-full">
                        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 mb-1">
                            <FaUser className="w-5 h-5" />
                        </div>
                        <p className="text-neutral-800 font-semibold text-base truncate w-full text-center">
                            {profile?.name || user}
                        </p>
                        {profile?.email && (
                            <p className="text-xs text-neutral-500 truncate w-full text-center">
                                {profile.email}
                            </p>
                        )}
                        {profile?.gender && (
                            <span className="text-[11px] font-medium text-zinc-500 mt-0.5">
                                {profile.gender === "FEMALE" ? "♀ Female" : "♂ Male"}
                            </span>
                        )}
                    </div>

                    <Separator className="my-1.5 bg-neutral-100" />

                    <div className="w-full">
                        <GenderPreferenceToggle onProfileLoaded={setProfile} />
                    </div>

                    <Separator className="my-1.5 bg-neutral-100" />

                    <a
                        href="/terms-and-conditions"
                        className="flex gap-2.5 items-center w-full text-left px-3 py-2 hover:bg-neutral-100 rounded-lg transition-colors text-neutral-700 text-sm font-medium"
                    >
                        <FaBriefcase className="text-neutral-500" /> Terms and Conditions
                    </a>
                    <a
                        href="/feedback"
                        className="flex gap-2.5 items-center w-full text-left px-3 py-2 hover:bg-neutral-100 rounded-lg transition-colors text-neutral-700 text-sm font-medium"
                    >
                        <FaComment className="text-neutral-500" /> Feedback
                    </a>
                    <Button
                        variant="ghost"
                        className="w-full flex items-center gap-2.5 text-left px-3 py-2 text-red-500 hover:bg-red-50 hover:text-red-600 font-medium rounded-lg justify-start mt-0.5 text-sm"
                        onClick={() => setModal(true)}
                    >
                        <FaRightFromBracket className="text-red-400" />
                        Logout
                    </Button>
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default ProfileBtn;
